import { render, staticRenderFns } from "./PaymentMethodValidationForm.vue?vue&type=template&id=3dc80910&scoped=true"
import script from "./PaymentMethodValidationForm.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodValidationForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentMethodValidationForm.vue?vue&type=style&index=0&id=3dc80910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc80910",
  null
  
)

export default component.exports